import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const StakeholderRoster = ({ stakeholders, onInviteStakeholder }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Active': return 'text-success bg-success/10';
      case 'Pending': return 'text-warning bg-warning/10';
      case 'Inactive': return 'text-muted-foreground bg-muted';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  const getRoleIcon = (role) => {
    switch (role) {
      case 'Property Owner': return 'Home';
      case 'Real Estate Lawyer': return 'Scale';
      case 'Certified Engineer': return 'HardHat';
      case 'Licensed Notary': return 'Stamp';
      case 'Real Estate Broker': return 'Briefcase';
      default: return 'User';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-soft">
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-foreground">Stakeholder Roster</h3>
          <Button 
            variant="outline" 
            iconName="UserPlus" 
            iconPosition="left"
            onClick={onInviteStakeholder}
          >
            Invite Stakeholder
          </Button>
        </div>

        <div className="space-y-4">
          {stakeholders?.map((stakeholder) => (
            <div key={stakeholder?.id} className="flex items-center justify-between p-4 bg-muted/30 rounded-lg">
              <div className="flex items-center space-x-4">
                <div className="relative">
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-muted">
                    <Image 
                      src={stakeholder?.avatar} 
                      alt={stakeholder?.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-background rounded-full flex items-center justify-center border border-border">
                    <Icon name={getRoleIcon(stakeholder?.role)} size={12} className="text-primary" />
                  </div>
                </div>
                
                <div>
                  <h4 className="font-medium text-foreground">{stakeholder?.name}</h4>
                  <p className="text-sm text-muted-foreground">{stakeholder?.role}</p>
                  <p className="text-xs text-muted-foreground">{stakeholder?.email}</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="text-right">
                  <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(stakeholder?.status)}`}>
                    <div className={`w-1.5 h-1.5 rounded-full mr-1 ${
                      stakeholder?.status === 'Active' ? 'bg-success' :
                      stakeholder?.status === 'Pending' ? 'bg-warning' : 'bg-muted-foreground'
                    }`} />
                    {stakeholder?.status}
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">
                    {stakeholder?.documentsCompleted}/{stakeholder?.totalDocuments} docs
                  </p>
                </div>

                <div className="flex items-center space-x-2">
                  <Button variant="ghost" size="icon">
                    <Icon name="MessageCircle" size={16} />
                  </Button>
                  <Button variant="ghost" size="icon">
                    <Icon name="MoreVertical" size={16} />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Summary Stats */}
        <div className="mt-6 pt-6 border-t border-border">
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <p className="text-2xl font-bold text-success">
                {stakeholders?.filter(s => s?.status === 'Active')?.length}
              </p>
              <p className="text-sm text-muted-foreground">Active</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-warning">
                {stakeholders?.filter(s => s?.status === 'Pending')?.length}
              </p>
              <p className="text-sm text-muted-foreground">Pending</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-foreground">
                {stakeholders?.length}
              </p>
              <p className="text-sm text-muted-foreground">Total</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StakeholderRoster;